import axios from 'axios'
import store from '../store'

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken');
axios.defaults.headers.get['Accept'] = 'application/json';
axios.defaults.headers.get['Content-Type'] = 'application/json';

axios.interceptors.response.use(function(response) {
    return response
}, function(error) {
    if (error.response.status === 401) {
        store.dispatch('logout')
        window.location = '/login'
    }
    return Promise.reject(error)
})
export default axios
